export default class Lang {

  static get common_namepsace() {
    return 'common';
  }

  constructor() {
    this._texts = {
      [Lang.common_namepsace] : {}
    };
  }

  get texts() {
    return this._texts;
  }

  hasNamespace(namespace) {
    return this.texts.hasOwnProperty(namespace);
  }

  hasText(key, namespace = Lang.common_namepsace) {

    if(!this.hasNamespace(namespace)) {
      return false;
    }

    return this.texts[namespace].hasOwnProperty(key);
  }

  addTexts(texts, namespace = Lang.common_namepsace) {

    if(this.hasNamespace(namespace)) {
      this._addTextsToExistingNamespace(namespace, texts);
      return;
    }

    this.texts[namespace] = texts;
  }

  _addTextsToExistingNamespace(namespace, texts) {
    Object.assign(this.texts[namespace], texts);
  }

  format(key, args) {
    return sprintf(
      this.getText(key),
      args
    );
  }

  getText(key, namespace = Lang.common_namepsace) {
    return this.hasText(key, namespace) ?
      this.texts[namespace][key] : key;
  }

  getTextsByNamespace(namespace = this.common_namepsace) {
    return this.hasNamespace(namespace) ?
      this.texts[namespace] : [];
  }

};



/** WEBPACK FOOTER **
 ** ./src/common/lang.js
 **/